<ion-content class="background">
  <div class="header-page">
    <div class="title">
      <ion-label color="dark">Confirmación de solicitud de toma de muestra</ion-label>
    </div>
  </div>

  <ion-grid class="form-data">
    <ion-row class="sample-target">
      <ion-col size="12">
        <div class="paragraph_container">
          <p>
            La solicitud de toma de muestra que estás a punto de hacer
            <span class="highlight">será gestionada por un proveedor externo.</span>
            No aplica para toma de muestras
            realizadas por vos mismo.
          </p>

          <p>
            Si ya has realizado la toma de la muestra,
            por favor selecciona el servicio de “retiro
            de muestra” en su lugar.
          </p>

          <p>
            Confirma si deseas proceder con la
            solicitud actual o si prefieres elegir otro
            tipo de servicio.
          </p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer class="ion-no-border" >
  <ion-grid>
    <ion-row>
      <ion-col size="12" class="center">
        <button shape="round" class="btn-primary-2 btn-close" (click)="navigateToSample('sample')">Continuar</button>
      </ion-col>
      <ion-col size="12" class="center">
        <button shape="round" class="btn-primary btn-close" (click)="closeModal()">Volver al inicio</button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>

